import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';

export interface ModuleCloseStatus {
  module: string;
  status: 'Open' | 'SoftClosed' | 'HardClosed' | 'Locked';
  workflowStatus: 'None' | 'Submitted' | 'Approved' | 'Rejected';
  closedBy: string | null;
  closedDate: string | null;
  entryId: string | null;
}

export interface MonthEndStatus {
  financialYearCode: string;
  financialPeriodCode: string;
  periodName: string;
  periodStart: string;
  periodEnd: string;
  unpostedJournals: number;
  pendingApprovals: number;
  overdueApprovals: number;
  unreconciledBankAccounts: number;
  unmatchedAllocations: number;
  failedPostingQueueItems: number;
  failedIntegrationBatches: number;
  unreconciledCardSettlements: number;
  isGlClosed: boolean;
  isArClosed: boolean;
  isApClosed: boolean;
  isBankingClosed: boolean;
  moduleStatuses: ModuleCloseStatus[];
  isReadyToClose: boolean;
  blockingReasons: string[];
  asAt: string;
}

export const monthEndApi = {
  getStatus: (yearCode: string, periodCode: string) =>
    apiClient.get<ApiResponse<MonthEndStatus>>(
      `/month-end/status?financialYearCode=${encodeURIComponent(yearCode)}&financialPeriodCode=${encodeURIComponent(periodCode)}`
    ),

  initiate: (yearCode: string, periodCode: string) =>
    apiClient.post<ApiResponse<MonthEndStatus>>('/month-end/initiate', {
      financialYearCode: yearCode,
      financialPeriodCode: periodCode,
    }),

  forceClose: (yearCode: string, periodCode: string, overrideReason: string) =>
    apiClient.post<ApiResponse<MonthEndStatus>>('/month-end/force-close', {
      financialYearCode: yearCode,
      financialPeriodCode: periodCode,
      overrideReason,
    }),

  approve: (yearCode: string, periodCode: string) =>
    apiClient.post<ApiResponse<MonthEndStatus>>('/month-end/approve', {
      financialYearCode: yearCode,
      financialPeriodCode: periodCode,
    }),

  reopen: (yearCode: string, periodCode: string, reopenReason: string) =>
    apiClient.post<ApiResponse<MonthEndStatus>>('/month-end/reopen', {
      financialYearCode: yearCode,
      financialPeriodCode: periodCode,
      reopenReason,
    }),
};
